import axios from 'axios';
import { Dispatch, AnyAction } from 'redux';
import { apiURL } from '../../../config';
import { User } from './auth.types';
import { setToken } from '../../../utils/localStorage';

export const USER_LOADING = 'USER_LOADING';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

export const registerUser = (user: User) => async (
  dispatch: Dispatch<AnyAction>
) => {
  dispatch({ type: USER_LOADING });
  try {
    const res = await axios.post(`${apiURL}/api/auth/register`, user);
    dispatch({ type: CREATE_USER_SUCCESS, payload: res.data });
    setToken(res.data.token);
    return res;
  } catch (error) {
    dispatch({
      type: CREATE_USER_FAILURE,
      payload: error.response?.data.error,
    });
    return error;
  }
};

export const loginUser = (user: User) => async (
  dispatch: Dispatch<AnyAction>
) => {
  dispatch({ type: USER_LOADING });
  try {
    const res = await axios.post(`${apiURL}/api/auth/login`, user);
    dispatch({ type: USER_LOGIN_SUCCESS, payload: res.data });
    setToken(res.data.token);
    return res;
  } catch (error) {
    dispatch({
      type: CREATE_USER_FAILURE,
      payload: error.response?.data.error,
    });
    return error;
  }
};
